import Alpine from 'alpinejs'

window.Alpine = Alpine

function parseNotifications () {
    try {
        return JSON.parse(localStorage.getItem('notifications')) || [];
    } catch (e) {
        return [];
    }
}

function parseDismissed() {
    try {
        return JSON.parse(localStorage.getItem('dismissed')) || [];
    } catch (e) {
        return [];
    }
}

function addToDismissed(id) {
    const dismissed = parseDismissed();

    dismissed.push(id);

    localStorage.setItem('dismissed', JSON.stringify([...new Set(dismissed)]));

    return dismissed;
}

function updateNumberOfNotifications(number) {
    localStorage.setItem('number_of_notifications', number);
}

Alpine.store('notifications', {
    init() {
        this.notifications = parseNotifications();
        this.dismissed = parseDismissed();
        this.number_of_notifications = localStorage.getItem('number_of_notifications') ?? 0;
    },
    updateNotifications() {
        this.notifications = parseNotifications();
        this.updating = false;
        this.notificationsFiltered;
    },
    dismiss(notification_id) {
        this.dismissed = addToDismissed(notification_id);
    },

    get notificationsFiltered() {
        const filtered = this.notifications.filter((notification)=>!this.dismissed.includes(notification.id));
        updateNumberOfNotifications(filtered.length);
        this.number_of_notifications = filtered.length;
        return filtered;
    },

    updating: true,
    notifications: [],
    dismissed: [],
    number_of_notifications: 0,
});

Alpine.data('notification', (notification_id)=>({
    dismissBtn: {
        ['@click']() {
            Alpine.store('notifications').dismiss(notification_id);
        },
    },
}));

Alpine.start()
console.log('Alpine started');
